import { Box, Container, Grid } from '@mui/material'
import React from 'react'
import earn from '../../assets/video/earn.mp4'
import earnpng from '../../assets/img/earn.png'
import twitter from "../../assets/img/twitter.png"
import telegram from "../../assets/img/telegram.png"
import { ButtonEx, GridEx, PageWrapper, SocialImg, SocialMeidaBox, TypographyEx } from '../../styles'
import { telegramLink, twitterLink } from '../config'

const Earn = () => {
  return (
    <PageWrapper>
        <Container maxWidth="xl">
            <Grid container>
                <GridEx xs={12} md={5} lg={4} item>
                    <video style={{width: '100%', maxWidth: 400}} loop autoPlay muted>
                        <source src={earn} type="video/mp4" />
                        Your browser does not support HTML video.
                    </video>
                    <img src={earnpng} alt="earn-main-image" className='mainImg' />
                </GridEx>
                <GridEx xs={12} md={7} lg={8} item center>
                    <TypographyEx variant="inherit" align="right">
                    My savings have been rugged to oblivion and I am sick of coping with these circumstances. Join me in my endeavors to get a "real job" at McDonald's. I aspire to be a competent hygiene technician.<br /><br />
                    With McWojak's state of the art portal linked below, you can make upwards of $1,100 a month depending on where you live!
                    </TypographyEx>
                    <SocialMeidaBox>
                        <a href={twitterLink} target='_blank'>
                            <SocialImg src={twitter} alt="twitter-logo" />
                        </a>
                        <a href={telegramLink} target='_blank'>
                            <SocialImg src={telegram} alt="telegram-logo" />
                        </a>
                    </SocialMeidaBox>
                    <Box sx={{textAlign: "right", mt:6 }}>
                        <ButtonEx bg="#000000"><a href='https://www.liveworksheets.com/xz1352521dx' target='_blank' style={{color:'#fff'}}>APPLY NOW</a></ButtonEx>
                    </Box>
                    <img src={earnpng} alt="earn-main-image" className='primaryImg' />
                </GridEx>
            </Grid>
        </Container>
    </PageWrapper>
  )
}

export default Earn